<template>
    <div class="data-title">
        <div class="text">
            <slot>
                {{ title }}
            </slot>
        </div>
        <img src="../imgs/Group 291.png" alt="" class="image" />
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        title: String,
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.data-title {
    position: relative;

    .text {
        position: absolute;
        left: 26px;
        top: 2px;
    }
}
</style>
